// extracted by mini-css-extract-plugin
export default {"dateGroup":"TournamentList_dateGroup__mL8+j","dateHeading":"TournamentList_dateHeading__LV1vF"};